import React from 'react';
import { Link, useSearchParams } from 'react-router-dom';

const AuthRejected: React.FC = () => {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');

  let title = "Authentication Failed";
  let message = "An unknown error occurred during authentication.";

  if (reason === 'pending_approval') {
    title = "Account Pending Approval";
    message = "Your student account is pending approval from a mentor. We will notify you when your account is ready!";
  } else if (reason === 'access_denied') {
    title = "Access Denied";
    message = "You do not have the required permissions to access this page.";
  } else if (reason === 'google_failed') {
    message = "Google Sign-In was cancelled or failed.";
  }

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <div className="max-w-md bg-white p-6 rounded-md shadow-lg text-center">
        <h1 className="text-2xl font-bold text-red-600">{title}</h1>
        <p className="mt-3 text-gray-600">{message}</p>
        <Link
          to="/login"
          className="mt-5 inline-block bg-blue-600 text-white px-6 py-2 rounded-md font-medium hover:bg-blue-700 transition"
        >
          Return to Login
        </Link>
      </div>
    </div>
  );
};

export default AuthRejected;